import React from "react";
import { TrendingUp, Share2, Eye, Star, Award } from "lucide-react";
import { useLanguage } from "../../i18n";

const ImpactSection = () => {
  const { t } = useLanguage();
  const impactItems = t('impact.items');
  const icons = [TrendingUp, Share2, Eye, Star, Award];
  
  const impacts = Array.isArray(impactItems) 
    ? impactItems.map((text, index) => ({ icon: icons[index], text }))
    : [
        { icon: TrendingUp, text: "Alto potencial viral en redes sociales" },
        { icon: Share2, text: "Generación de contenido orgánico por asistentes" },
        { icon: Eye, text: "Cobertura mediática" },
        { icon: Star, text: "Experiencia memorable de marca" },
        { icon: Award, text: "Diferenciación frente a competencia" },
      ];

  return (
    <section id="impacto" className="py-24 md:py-32 bg-[#050505]" data-testid="impact-section">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            {t('impact.title')}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
              {t('impact.titleHighlight')}
            </span>
          </h2>
        </div>
        
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {impacts.map((item, index) => (
            <div 
              key={index}
              className="flex items-center gap-4 p-6 rounded-xl bg-white/5 border border-white/10 hover:border-cyan-500/30 transition-all hover:bg-white/[0.07]"
            >
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-gradient-to-br from-cyan-500/20 to-blue-600/20 flex items-center justify-center">
                <item.icon className="w-6 h-6 text-cyan-400" />
              </div>
              <p className="text-white font-medium">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImpactSection;
